"use client";

import { useEffect, useState } from "react";

import { getAdminBaseUrl } from "./host.utils";

/**
 * Resolves the admin base URL safely for client components.
 *
 * The initial render uses the env-var-only result (safe for SSR hydration).
 * After mount, the hook additionally resolves from `window.location.hostname`,
 * which covers snap/preview/prod domains when the env var is absent.
 */
export function useAdminBaseUrl(): string | undefined {
  const [adminBaseUrl, setAdminBaseUrl] = useState(() => getAdminBaseUrl());

  useEffect(() => {
    setAdminBaseUrl(getAdminBaseUrl(window.location.hostname));
  }, []);

  return adminBaseUrl;
}
